import { useEffect, useState } from "react";

import CoreModal from "@pages/SupplyChain/components/InventoryOverview/modals/CoreModal";
import { FormInputWrapper } from "@pages/SupplyChain/components/InventoryOverview/modals/CoreModal/FormInputWrapper";
import { FormSelectWrapper } from "@pages/SupplyChain/components/InventoryOverview/modals/CoreModal/FormSelectWrapper";
import { Plus } from "lucide-react";
import styles from "../styles.module.scss";
import FreightTable from "./FreightTable";
import { FreightRow } from "./utils";

export const FreightTab: React.FC = () => {
  const [openModal, setOpenModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selected, setSelected] = useState<FreightRow | null>(null);
  const [formData, setFormData] = useState({
    method: "",
    name: "",
    supplier: "",
    minWeight: "",
    minVolumetricWeight: "",
    sizyType: "",
    defaultLeadTime: "",
    region: "",
    loadingType: "",
    costPerPound: "",
    costPerVolume: "",
  });

  useEffect(() => {
    if (isEditMode && selected) {
      setFormData({
        method: "",
        name: "",
        supplier: "",
        minWeight: "",
        minVolumetricWeight: "",
        sizyType: "",
        defaultLeadTime: "",
        region: "",
        loadingType: "",
        costPerPound: "",
        costPerVolume: "",
      });
    } else {
      setFormData({
        method: "",
        name: "",
        supplier: "",
        minWeight: "",
        minVolumetricWeight: "",
        sizyType: "",
        defaultLeadTime: "",
        region: "",
        loadingType: "",
        costPerPound: "",
        costPerVolume: "",
      });
    }
  }, [isEditMode, selected]);

  const handleChangeValue = (value: string, name: string) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (value: string, name: string) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleEdit = (item: FreightRow) => {
    setSelected(item);
    setIsEditMode(true);
    setOpenModal(true);
  };

  const handleDelete = (item: FreightRow) => {
    console.log("Delete ", item);
  };

  const form = (
    <>
      <FormSelectWrapper
        label="Freight Method"
        placeholder="Select id"
        value={formData.method}
        onChange={(value: string) => handleSelectChange(value, "method")}
        options={[
          { id: "Air", text: "Air" },
          { id: "See", text: "See" },
          { id: "Train", text: "Train" },
        ]}
      />
      <div className={styles.row}>
        <FormInputWrapper
          label="Freight Name"
          placeholder="Fast Air UK"
          value={formData.name}
          onChange={(value) => handleChangeValue(value, "name")}
        />
        <FormSelectWrapper
          label="supplier"
          placeholder="Select id"
          value={formData.supplier}
          onChange={(value: string) => handleSelectChange(value, "supplier")}
          options={[
            { id: "Supplier C1", text: "Supplier C1" },
            { id: "Supplier C2", text: "Supplier C2" },
            { id: "Supplier C3", text: "Supplier C3" },
          ]}
        />
      </div>
      <div className={styles.row}>
        <FormInputWrapper
          label="Minimum weight"
          placeholder="2 lbs"
          value={formData.minWeight}
          onChange={(value) => handleChangeValue(value, "minWeight")}
        />
        <FormInputWrapper
          label="Minimum volumetric weight"
          placeholder="3 lbs"
          value={formData.minVolumetricWeight}
          onChange={(value) => handleChangeValue(value, "minVolumetricWeight")}
        />
      </div>
      <div className={styles.row}>
        <FormInputWrapper
          label="Size type"
          placeholder="< 2.44 x 3.15 m"
          value={formData.sizyType}
          onChange={(value) => handleChangeValue(value, "sizyType")}
        />
        <FormInputWrapper
          label="Default lead time"
          placeholder="10d"
          value={formData.defaultLeadTime}
          onChange={(value) => handleChangeValue(value, "defaultLeadTime")}
        />
      </div>
      <div className={styles.row}>
        <FormSelectWrapper
          label="Region"
          placeholder="Select region"
          value={formData.region}
          onChange={(value: string) => handleSelectChange(value, "region")}
          options={[
            { id: "UK", text: "UK" },
            { id: "EN", text: "EN" },
            { id: "USA", text: "USA" },
          ]}
        />
        <FormInputWrapper
          label="Loading Type"
          placeholder="Euro pallet cages"
          value={formData.loadingType}
          onChange={(value) => handleChangeValue(value, "loadingType")}
        />
      </div>
      <div className={styles.row}>
        <FormInputWrapper
          label="Cost per pound"
          placeholder="£4.80"
          value={formData.costPerPound}
          onChange={(value) => handleChangeValue(value, "costPerPound")}
        />
        <FormInputWrapper
          label="Cost per volume"
          placeholder="£34.80"
          value={formData.costPerVolume}
          onChange={(value) => handleChangeValue(value, "costPerVolume")}
        />
      </div>
    </>
  );

  return (
    <div>
      <div className={styles.toolbar}>
        <button
          className={styles.blueButton}
          onClick={() => setOpenModal(true)}
        >
          <Plus width={16} height={16} stroke="#fff" fontWeight={"bold"} />
          add freight method
        </button>
      </div>

      <FreightTable onEdit={handleEdit} onDelete={handleDelete} />

      <CoreModal
        onCancel={() => setOpenModal(false)}
        open={openModal}
        title={isEditMode ? "Edit Freight" : "Add Freight"}
        children={form}
      />
    </div>
  );
};
